import type { FC } from 'react'

const ErrorContainer: FC = () => <p>Error Page</p>

export default ErrorContainer
